import React from 'react';
import PropTypes from 'prop-types';
import GalleryBlockView from './GalleryBlockView';
import MediaLibrary from '../../media/MediaLibrary';
import useGalleryBlockEditor from './useGalleryBlockEditor';

/**
 * GalleryBlockEditor — container do bloco Galeria (blockType 8). docs/PLANO-EXECUCAO-MIDIA.md TODO 7.3.
 * Visual: GalleryBlockView + MediaLibrary (View do Claude Design + aviso da casa). Regra e dado: useGalleryBlockEditor.
 *
 * Props (as do registro de blocos — BlockList):
 *   - value: config do bloco — { layout, items: [{ assetId, origem, w, h, color, caption?, alt? }], images: [antigos] }
 *   - onChange: (novoConfig) => void
 */
const GalleryBlockEditor = ({ value = {}, onChange }) => {
  const { vm, actions, library } = useGalleryBlockEditor({ value, onChange });
  return (
    <>
      <GalleryBlockView vm={vm} actions={actions} />
      <MediaLibrary vm={library.vm} actions={library.actions} />
    </>
  );
};

GalleryBlockEditor.propTypes = {
  value: PropTypes.shape({
    layout: PropTypes.number,
    items: PropTypes.arrayOf(PropTypes.object),
    images: PropTypes.arrayOf(PropTypes.object),
  }),
  onChange: PropTypes.func.isRequired,
  context: PropTypes.object,
};

export default GalleryBlockEditor;
